import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

import { Alert, AlertTitle, Divider, List, ListItem } from '@mui/material'
import AddressOcrProblemsList from 'components/DueDiligence/Questions/AddressOcrProblemsList'
import { getAttachmentDownloadLink } from 'services/apiKYP'
import { useSelector } from 'react-redux'
import { TRANSLATED_ADDRESS_PROOF_THIRD_PARTY_TYPES } from 'utils/constants/addressOcr'
import _ from 'lodash'
import styles from './styles'

function BuildAddressOcrReviewInfo(props) {
  const { reviewData } = props
  const [attachmentDownloadLink, setAttachmentDownloadLink] = useState(undefined)
  const token = useSelector((state) => state.auth.access_token)

  const classes = styles()
  const ocrData = reviewData?.address_ocr_data
  const attachmentUuid = ocrData?.final_attachment?.uuid
  const inputData = ocrData?.latest_try?.input_data
  const validations = ocrData?.latest_try?.response_data?.validations
  const thirdPersonNames = _.entries(_.pick(inputData, ['father_name', 'mother_name', 'spouse_name']))

  // If present: Pos 0 relation type, Pos 1 person name
  const thirdPerson = _.find(thirdPersonNames, (val) => !_.isEmpty(val[1]))

   useEffect(() => {
    getAttachmentDownloadLink(token, attachmentUuid).then((response) => {
      setAttachmentDownloadLink(response.data.document_url)
    }).catch(setAttachmentDownloadLink(null))
  }, [attachmentUuid])

  const buildListItem = (title, text) => {
    return (
      <ListItem>
        <b style={{ fontWeight: 600 }}>{title}:&nbsp;</b>
        {text}
      </ListItem>
    )
  }

  return (
    <div className={classes.root}>
      <h3>O assessor não enviou um comprovante de residência válido</h3>
      <p>
        {reviewData.reason}.
      </p>

      {reviewData.continued_without_validation &&
        <p>
          O assessor tentou enviar múltiplos comprovantes de residência, porém nenhuma das tentativas foi validada pelo sistema.
          Por fim, aceitou continuar sob risco de reprovação.
        </p>
      }
      <div style={{ marginTop: 30, width: '100%' }}>
        {attachmentDownloadLink && <p>
          O último comprovante de residência enviado foi:&nbsp;
          <a href={attachmentDownloadLink}>{ocrData?.final_attachment?.filename}</a>
        </p>}

        {attachmentDownloadLink === null && <Alert severity="error" color="error" variant="outlined" >Ocorreu um erro ao recuperar o arquivo do comprovante de residência enviado pelo assessor</Alert>}

        {reviewData.continued_without_validation && (
          <Alert severity="warning" color="error" variant="outlined">
            <AlertTitle>Resultado da validação do comprovante de residência</AlertTitle>
            <AddressOcrProblemsList inputData={inputData} validations={validations} isInProspectView={false} />
          </Alert>
        )}

        <br></br>
        <br></br>

        Baixe o arquivo enviado pelo assessor e confirme a veracidade das informações prestadas abaixo.

        <br></br>
        <br></br>


        <Divider></Divider>

        <br></br>


        <h4>Dados preenchidos pelo assessor no Onboarding</h4>
        <List>
          {buildListItem('Logradouro', inputData?.street_address)}
          {buildListItem('Número', inputData?.number)}
          {buildListItem('Cidade', inputData?.city)}
          {buildListItem('Bairro', inputData?.neighborhood)}
          {buildListItem('Estado', inputData?.state)}
          {buildListItem('CEP', inputData?.zip_code)}
        </List>

        <br></br>

        <List>
          {buildListItem(
            'O comprovante de residência está em nome do próprio assessor',
            _.isEmpty(inputData.person_name) ? 'Não' : 'Sim',
          )}
          {!_.isEmpty(inputData.person_name) && buildListItem(
            'Como está o nome do assessor no comprovante (informado por ele)',
            inputData.person_name,
          )}
          {!_.isEmpty(thirdPerson) &&
            buildListItem(
              'Nome do terceiro a quem se refere o comprovante',
              thirdPerson[1],
            )}
          {!_.isEmpty(thirdPerson) &&
            buildListItem(
              'Relação do terceiro a quem se refere o comprovante',
              TRANSLATED_ADDRESS_PROOF_THIRD_PARTY_TYPES[thirdPerson[0]],
            )}
        </List>

        <br></br>
        <Divider></Divider>
        <br></br>
      </div>
    </div>
  )
}

BuildAddressOcrReviewInfo.propTypes = {
  reviewData: PropTypes.object.isRequired,
}

export default BuildAddressOcrReviewInfo
